//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  const uia = angular.module('uia');
  uia.component('showroomSettingsTrackingParams', {
    bindings: {
      startingParamsString: '<',
      curalateParamKey: '<',
    },
    template: require('@legacy-components/common/universal-image-actions/showroom-settings-tracking-params.html'),
    controller: [
      '$element',
      '$scope',
      'SessionVarsService',
      'ShowroomApiService',
      'ShowroomService',
      'TrackingService',
      function (
        $element,
        $scope,
        SessionVarsService,
        ShowroomApiService,
        ShowroomService,
        TrackingService,
      ) {
        this.validCustomParamsRegex = /^[^&=?]*$/;

        this.isTrackingParamsV2Enabled = SessionVarsService.isFeatureEnabled('url_tracking_params_v2');
        this.trackingParams = {};
        this.trackingParamsStringPreview = '';
        this.curalateParamKeyName = '';
        this.customTrackingParams = [];
        this.paramsCollapsed = true;
        this.hadGaParamsOnInit = false;

        this.sectionTitle = '';
        this.sectionSubtitle = '';

        const GA_PARAM_NAMES = {
          utm_source: 'Source',
          utm_campaign: 'Campaign Name',
          utm_content: 'Campaign Content',
          utm_term: 'Campaign Term',
          utm_medium: 'Campaign Medium',
        };
        const GA_PARAMS = ['utm_source', 'utm_campaign', 'utm_content', 'utm_term', 'utm_medium'];

        const parseTrackingParams = () => {
          this.startingParamsString = this.startingParamsString || '';
          const params = this.startingParamsString.split(',');
          _(params).each((param) => {
            const paramSplit = param.split('=');

            if (paramSplit.length !== 2) {
              return;
            }

            const name = decodeURIComponent(paramSplit[0]);
            const value = decodeURIComponent(paramSplit[1]);

            if (_(GA_PARAMS).contains(name)) {
              this.hadGaParamsOnInit = true;
              this.trackingParams[name] = value;
            } else {
              this.customTrackingParams.push({ name, value });
            }
          });
        };

        const buildCustomParamsMap = () => {
          const customParamsMap = {};
          _(this.customTrackingParams).each((paramEntry) => {
            if (paramEntry.name && paramEntry.value) {
              const paramObject = {
                [paramEntry.name]: paramEntry.value,
              };
              Object.assign(customParamsMap, paramObject);
            }
          });
          return customParamsMap;
        };

        const buildJoinedParamsMap = () => {
          const customParamsMap = buildCustomParamsMap();
          return Object.assign(angular.copy(this.trackingParams), customParamsMap);
        };

        const buildPreviewString = () => {
          const paramsMap = buildJoinedParamsMap();
          const previewString = ShowroomService.buildTrackingParamsString(paramsMap, true);
          return previewString;
        };

        this.removeParamAtIndex = (index) => {
          this.customTrackingParams.splice(index, 1);
          this.updateTrackingParams();
        };

        this.updateTrackingParams = () => {
          const paramSet = buildJoinedParamsMap();
          this.trackingParamsStringPreview = buildPreviewString();
          ShowroomService.updateTrackingParams(paramSet, this.hadGaParamsOnInit);
        };

        this.openCustomParams = () => {
          this.customTrackingParams.push({ name: '', value: '' });
          const workflowPanel = $('.uia-workflow-panel');
          const destScroll = $('#tributary-custom-params-section').offset().top + workflowPanel.scrollTop() - 20; // -20 for padding

          workflowPanel.animate({
            scrollTop: destScroll,
          },
            600, // Animation length
            () => {
              $('.custom-param-name > input').last().focus();
            });
        };

        this.toggleParamsCollapsed = () => {
          this.paramsCollapsed = !this.paramsCollapsed;
          TrackingService.recordEvent(
            this.trackingCategory,
            this.trackingAction,
            this.trackingLabels.toggleParamSettings(this.paramsCollapsed),
          );
        };

        this.setModelAndUpdate = (selectedVal, paramToUpdate) => {
          this.trackingParams[paramToUpdate] = selectedVal;
          this.updateTrackingParams();
        };

        this.setModelAndUpdateCustom = (selectedVal, paramToUpdate, paramIndex, name) => {
          if (name) {
            this.customTrackingParams[paramIndex].name = selectedVal;
          } else {
            this.customTrackingParams[paramIndex].value = selectedVal;
          }
          this.updateTrackingParams();
        };

        this.$onInit = () => {
          this.trackingCategory = ShowroomService.getTrackingCategory();
          this.trackingAction = ShowroomService.getTrackingAction();
          this.trackingLabels = {
            toggleParamSettings: (collapsed) => { return (collapsed) ? 'CollapseParamSettings' : 'OpenParamSettings'; },
          };

          parseTrackingParams();
          this.trackingParamsStringPreview = buildPreviewString();
          this.curalateParamKeyName = GA_PARAM_NAMES[this.curalateParamKey];

          this.sectionTitle = 'Modify Tracking Parameters';
          this.sectionSubtitle = 'Track outbound traffic from your Showroom Links.';
        };
      },
    ],
  });
})();
